"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _dom_component = _interopRequireDefault(require("./component/dom_component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var Loading =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Loading, _PureComponent);

  /**
   * 属性说明
   * @alias LoadingProps
   * @description 用于页面和区块的加载中状态。
   * @property {titleline} 默认支持参数
   * @property {blankline} className;style;id;data-*;accessKey;dir;draggable;tabIndex;title;htmlRef;
   * @property {titleline} 基础属性
   * @property {bool} [show] 是否展示
   * @property {bool} [useNewUI=true] 是否使用新的风格
   * @property {string} [theme=''] 主题，默认为空，蓝色。可设置为 light 白色
   * @property {string} [display=''] 展示方式*可选值: inline-block, center*
   * @property {string} [stroke=#0b97ea] type==svg 的loading颜色
   * @property {number} [circleSize=100] type==svg loading圆形的大小
   * @property {number} [delay=0] 延迟展示，毫秒(只执行一次)
   * @property {string} [type='default'] loading类型*可选值: default，svg，page（default为区域；page为整个页面）*
   */
  function Loading(props) {
    var _this;

    _classCallCheck(this, Loading);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Loading).call(this, props));

    _this.nullList();

    _this.timeout = null;
    _this.state = {
      delayShow: !(props.delay > 0)
    };
    return _this;
  }

  _createClass(Loading, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setShow();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
      clearTimeout(this.timeout);
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.rootNode = null;
    }
  }, {
    key: "setShow",
    value: function setShow() {
      var _this2 = this;

      var delayShow = this.state.delayShow;
      var delay = this.props.delay;

      if (delay > 0 && !delayShow) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this2.setState({
            delayShow: true
          });
        }, delay);
      }
    }
  }, {
    key: "getDOMNode",
    value: function getDOMNode() {
      return this.rootNode || null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var children = this.props.children;
      var delayShow = this.state.delayShow;

      if (!delayShow) {
        return null;
      }

      return _react["default"].createElement(_dom_component["default"], _extends({}, this.props, {
        devProps: [Loading, this.props],
        htmlRef: function htmlRef(el) {
          _this3.rootNode = el;
        }
      }), children);
    }
  }]);

  return Loading;
}(_react.PureComponent); // 组件标记


_defineProperty(Loading, "propTypes", {
  show: _spauiUtils.PropTypes.bool,
  useNewUI: _spauiUtils.PropTypes.bool,
  theme: _spauiUtils.PropTypes.string,
  display: _spauiUtils.PropTypes.string,
  type: _spauiUtils.PropTypes.string,
  stroke: _spauiUtils.PropTypes.string,
  circleSize: _spauiUtils.PropTypes.number,
  delay: _spauiUtils.PropTypes.number
});

_defineProperty(Loading, "defaultProps", {
  type: '',
  display: '',
  stroke: '#0b97ea',
  circleSize: 100,
  delay: 0
});

(0, _spauiUtils.setComponentMark)(Loading, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = Loading;
exports["default"] = _default;